"use client";
import { useEffect } from 'react';

export const PreventScroll = () => {
  useEffect(() => {
    document.body.classList.add('overflow-hidden');
    return () => document.body.classList.remove('overflow-hidden');
  }, []);

  return null;
};
